import React from "react";
import {
  getDateToDisplay,
  getPeriodDateToDisplay,
} from "../../../../utils/nutrition-helpers";
import { parseTime } from "../../calendar/sleep-time/SleepTime";

const { round } = require("lodash");

const NutritionHistoryTableRow = ({
  utcDate,
  activeDayUtc,
  handleActiveDayChange,
  nutritionData,
  hasWorkout,
  startOfWeek,
  endOfWeek,
  isActiveDayPeriod,
  targetData,
  isCheckIn,
  isSingle,
}) => {
  const {
    proteins,
    carbs,
    fats,
    fibers,
    convertedBodyWeight,
    steps,
    kcal,
    isPeriod,
    sleep,
  } = nutritionData;

  const {
    targetCalories,
    targetProteins,
    targetCarbs,
    targetFats,
    targetFibers,
  } = targetData;

  // Get the adherence from the targets, if there is no plan, the adherence will be 0
  const proteinsAdherence = targetProteins
    ? round(targetProteins - (proteins ? proteins : 0), 1)
    : 0;
  const carbsAdherence = targetCarbs
    ? round(targetCarbs - (carbs ? carbs : 0), 1)
    : 0;
  const fatsAdherence = targetFats
    ? round(targetFats - (fats ? fats : 0), 1)
    : 0;
  const fibersAdherence = targetFibers
    ? round(targetFibers - (fibers ? fibers : 0), 1)
    : 0;
  const kcalAdherence = targetCalories ? round(targetCalories - kcal, 1) : 0;

  // Gets the percentage of the adherence, this is used to color the values properly
  const proteinsPercent = round((proteinsAdherence / targetProteins) * 100, 1);
  const carbsPercent = round((carbsAdherence / targetCarbs) * 100, 1);
  const fatsPercent = round((fatsAdherence / targetFats) * 100, 1);
  const fibersPercent = round((fibersAdherence / targetFibers) * 100, 1);
  const kcalPercent = round((kcalAdherence / targetCalories) * 100, 1);

  return (
    <React.Fragment>
      <tr
        className={`${
          utcDate === activeDayUtc && isPeriod === isActiveDayPeriod
            ? isPeriod
              ? "today-period"
              : "today"
            : ""
        } ${isPeriod ? "period-row" : ""}`}
        onClick={() => {
          if (!isCheckIn) handleActiveDayChange(utcDate, isPeriod);
        }}
      >
        <td>
          {isPeriod ? (
            isSingle ? (
              <span className="clipped font-bold">Average</span>
            ) : (
              getPeriodDateToDisplay(startOfWeek, endOfWeek)
            )
          ) : (
            `  ${getDateToDisplay(utcDate)}`
          )}
        </td>
        {/* Targets */}
        <td>{round(targetProteins, 0) || "-"}</td>
        <td>{round(targetCarbs, 0) || "-"}</td>
        <td>{round(targetFats, 0) || "-"}</td>
        <td>{round(targetFibers, 0) || "-"}</td>
        <td>{round(targetCalories, 0) || "-"}</td>
        {/* Consumed */}
        <td>{round(proteins, 0) || "-"}</td>
        <td>{round(carbs, 0) || "-"}</td>
        <td>{round(fats, 0) || "-"}</td>
        <td>{round(fibers, 0) || "-"}</td>
        <td>{round(kcal, 0) || "-"}</td>
        {/* Adherence */}
        {renderAdherenceValue(proteinsAdherence, proteinsPercent)}
        {renderAdherenceValue(carbsAdherence, carbsPercent)}
        {renderAdherenceValue(fatsAdherence, fatsPercent)}
        {renderAdherenceValue(fibersAdherence, fibersPercent)}
        {renderAdherenceValue(kcalAdherence, kcalPercent)}
        {/* Check In conditional */}
        {!isCheckIn && (
          <>
            {/* Bodyweight */}
            <td>{round(convertedBodyWeight, 0) || "-"}</td>
            {/* Steps */}
            <td>{kConverter(steps || 0) || "-"}</td>
            {/* Sleep */}
            <td>{sleep ? parseTime(sleep) : "-"}</td>

            {/* Display the icon if the workout has been done for the day */}
            {hasWorkout ? (
              <td>
                <div className="icon-div">
                  <img src="/img/new-icons/tick-gradient.svg" />
                </div>
              </td>
            ) : (
              <td />
            )}
          </>
        )}
      </tr>
      {isPeriod ? (
        isSingle ? (
          <React.Fragment />
        ) : (
          <tr className="blank-row" />
        )
      ) : (
        <React.Fragment />
      )}
    </React.Fragment>
  );
};

const kConverter = (number) => {
  const num = Number(number);

  if (num === 0) {
    return "-";
  }

  if (num < 1000) {
    return num.toFixed(0); // assuming an integer
  } else {
    const s = (0.1 * Math.floor(num / 100)).toFixed(1);
    return s.replace(".0", "") + "k";
  }
};

const renderAdherenceValue = (value, percent) => {
  return <td className={getTdClass(percent)}>{round(value, 0) || "-"}</td>;
};

const getTdClass = (percent) => {
  const absoluteValue = Math.abs(percent);
  if (absoluteValue >= 5 && absoluteValue < 10) {
    return "warning";
  } else if (absoluteValue >= 10) {
    return "danger";
  }
  return "";
};

export default NutritionHistoryTableRow;
